import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectAdditionalServices } from '../../selectors/promoInfo';
import { AdditionalServicesSection } from '../../components/AdditionalServicesSection';
import { trackAdditionalServiceClick } from './tracking';
import { IAdditionalService, TCommonDealDetailKeys } from '../../types/promoInfo';
import { setCommonDealDetailsModalId } from '../../actions';

/**
 * Секция "Способы взаиморасчётов".
 */
export const AdditionalServicesSectionContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const dispatch = useDispatch();
  const additionalServices = useSelector(selectAdditionalServices);

  const onAdditionalServiceClick = (service: IAdditionalService) => {
    dispatch(setCommonDealDetailsModalId(service.about as TCommonDealDetailKeys));
    trackAdditionalServiceClick(service.title);
  };

  return (
    <AdditionalServicesSection
      additionalServices={additionalServices}
      onAdditionalServiceClick={onAdditionalServiceClick}
    />
  );
};
